import applyHeatmap from './heatmaps.ts'
import { getGameSituation, getGameSituationSummary } from '../game-situation.ts'
import { GameSituation } from '../types/game-situation.ts'
import { WinProbabilityRow } from '../types/win-probabilty.ts'
import getVal from '../utils/win-prob-value.ts'

export default function renderWinProbabilityTable(data: WinProbabilityRow[]) {
    if (!data.length) {
        console.warn('No leverage index data returned')
    }

    const gameSituation = getGameSituation()

    // Determine if we need to flip the columns
    const shouldFlip = false
    /* gameSituation.perspective === 'bat' &&
        ((gameSituation.half === 'Top' && gameSituation.run_diff < 0) ||
            (gameSituation.half === 'Bottom' && gameSituation.run_diff >= 0)) */

    // Set Dynamic Headers
    const leftHeader =
        gameSituation.perspective === 'bat'
            ? 'Batting Team Losing'
            : 'Visiting Team'
    const rightHeader =
        gameSituation.perspective === 'bat'
            ? 'Batting Team Winning'
            : 'Home Team'

    const footer = gameSituation.perspective === 'bat' ? 'Batting' : 'Home'

    const table = `
<table id="tbl-win-prob">
  <thead>
    <tr class="secondary-header">
      <th colspan="4"></th>
      <th colspan="5"  class="th-title-header">${leftHeader}</th>
      <th></th>
      <th colspan="5"  class="th-title-header">${rightHeader}</th>
    </tr>    
    <tr class="tr-component-row">
      <th class="th-component-header align-center">Inning</th>
      <th class="th-component-header align-center">Top/Bot</th>
      <th class="th-component-header align-center">Outs</th>
      <th class="th-component-header align-center">Runners</th>
      <th class="th-component-header align-center border-left" data-diff="-5">-5</th>
      <th class="th-component-header align-center" data-diff="-4">-4</th>
      <th class="th-component-header align-center" data-diff="-3">-3</th>
      <th class="th-component-header align-center" data-diff="-2">-2</th>
      <th class="th-component-header align-center" data-diff="-1">-1</th>
      <th class="th-component-header align-center border-left" data-diff="0">Tie</th>
      <th class="th-component-header align-center border-left" data-diff="1">+1</th>
      <th class="th-component-header align-center" data-diff="2">+2</th>
      <th class="th-component-header align-center" data-diff="3">+3</th>
      <th class="th-component-header align-center" data-diff="4">+4</th>
      <th class="th-component-header align-center border-right" data-diff="5">+5</th>
    </tr>
  </thead>
  <tbody>
    ${data
        .map((row) => {
            const bases = row.bases_cd ?? ''

            return `
      <tr class="default-table-row" data-bases-cd="${bases}">
        <td class="tr-data align-center">${row.inning}</td>
        <td class="tr-data align-center">${row.bottom_top}</td>
        <td class="tr-data align-center">${row.outs}</td>
        <td class="tr-data align-center">${row.bases}</td>

<td class="tr-data align-center border-left" data-situation="-5">${getVal(
                row,
                shouldFlip,
                -5
            )}</td>
<td class="tr-data align-center" data-situation="-4">${getVal(
                row,
                shouldFlip,
                -4
            )}</td>
<td class="tr-data align-center" data-situation="-3">${getVal(
                row,
                shouldFlip,
                -3
            )}</td>
<td class="tr-data align-center" data-situation="-2">${getVal(
                row,
                shouldFlip,
                -2
            )}</td>
<td class="tr-data align-center" data-situation="-1">${getVal(
                row,
                shouldFlip,
                -1
            )}</td>
<td class="tr-data align-center border-left" data-situation="0">${getVal(
                row,
                shouldFlip,
                0
            )}</td>
<td class="tr-data align-center border-left" data-situation="1">${getVal(
                row,
                shouldFlip,
                1
            )}</td>
<td class="tr-data align-center" data-situation="2">${getVal(
                row,
                shouldFlip,
                2
            )}</td>
<td class="tr-data align-center" data-situation="3">${getVal(
                row,
                shouldFlip,
                3
            )}</td>
<td class="tr-data align-center" data-situation="4">${getVal(
                row,
                shouldFlip,
                4
            )}</td>
<td class="tr-data align-center border-right" data-situation="5">${getVal(
                row,
                shouldFlip,
                5
            )}</td>
      </tr>`
        })
        .join('')}
    <tr>
    <td colspan="4"></td>
    <td colspan="11" class="footer-title">Probability ${footer} Team Wins</td>
    </tr>        
  </tbody>
</table>
`
    const el = document.getElementById('game-strategy-explorer-table-wrapper')

    if (el) {
        el.innerHTML = table
    }
    applyHeatmap('tbl-win-prob')
    highlightMatchingRow(getGameSituation())

    const summaryEl = document.getElementById('summary')
    if (summaryEl) {
        const winProb = document.querySelector<HTMLElement>(
            '#tbl-win-prob .cell-highlight'
        )

        summaryEl.innerHTML = `<div><b><u>Start Situation</u></b>:<br/>${getGameSituationSummary(
            null
        )} <strong><span id="current-win-pct">${
            winProb?.innerHTML
        }</span>% WP for batting team</strong></div><hr class="situation-hr"></hr>`
    }
}

function highlightMatchingRow(situation: Partial<GameSituation>) {
    const BASE_MASK: Record<keyof GameSituation['runners'], number> = {
        '1b': 1,
        '2b': 2,
        '3b': 4,
    }

    document
        .querySelectorAll(
            '#game-strategy-explorer-table-wrapper .tr-data, ' +
                '#game-strategy-explorer-table-wrapper .cell-highlight'
        )
        .forEach((el) => el.classList.remove('cell-highlight'))

    const activeBasesCd = Object.entries(situation?.runners ?? {})?.reduce(
        (sum, [base, on]) => {
            if (!on) return sum
            return sum + BASE_MASK[base as keyof GameSituation['runners']]
        },
        0
    )

    const rows = document.querySelectorAll<HTMLTableRowElement>(
        '#game-strategy-explorer-table-wrapper table tbody tr'
    )

    const shouldFlip = false
    /* situation.perspective === 'bat' &&
        situation.half === 'Bottom' &&
        situation.run_diff >= 0 */

    let runDiff = situation.run_diff ?? 0

    if (shouldFlip) {
        runDiff *= -1
    }

    rows.forEach((row) => {
        const rowBasesCd = Number(row.dataset.basesCd ?? -1)

        if (rowBasesCd === activeBasesCd) {
            row.classList.add('row-highlight')

            const cell = row.querySelector<HTMLElement>(
                `[data-situation="${runDiff}"]`
            )
            cell?.removeAttribute('style')
            cell?.classList.add('cell-highlight')
        }
    })
}
